import { createStore, applyMiddleware, Reducer, Store, ActionCreatorsMapObject } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'connected-react-router/immutable';
import { History } from 'history';
import { DependencyList, useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector, shallowEqual, TypedUseSelectorHook } from 'react-redux';
import { AppDispatch, GTMStatisticMiddleware, RootState } from 'redux/store';

import SETTINGS from 'core/settings';
import { CORE_DEVELOPMENT, CORE_PRODUCTION } from 'core/constants';

export const configureStore = (
  rootReducer: Reducer<any, any>,
  history: History
): Store<any, any> => {
  const middlewares =
    // SETTINGS.environment === CORE_DEVELOPMENT
    SETTINGS.environment === CORE_PRODUCTION
      ? applyMiddleware(thunk, routerMiddleware(history), GTMStatisticMiddleware)
      : composeWithDevTools(applyMiddleware(thunk, routerMiddleware(history)));

  return createStore(rootReducer, middlewares);
};

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useActions = <A, M extends ActionCreatorsMapObject<A>>(
  actions: M,
  deps?: DependencyList
): M => {
  const dispatch = useAppDispatch();
  return useMemo(
    () => {
      return bindActionCreators(actions, dispatch);
    },
    deps ? [dispatch, ...deps] : [dispatch]
  );
};

export const useShallowEqualSelector = <TSelected>(
  selector: (state: RootState) => TSelected
): TSelected => {
  return useSelector<RootState, TSelected>(selector, shallowEqual);
};
